import { Link } from 'react-router-dom';
import { mangas, featuredMangaIds } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

export default function PopularSection() {
  const popularMangas = featuredMangaIds
    .map((id) => mangas.find((m) => m.id === id))
    .filter(Boolean);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的热门韩国漫画</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {popularMangas.map((manga) => manga && <MangaCard key={manga.id} manga={manga} />)}
        </div>
      </div>
    </section>
  );
}